<template>
  <div v-if="content.show">
    <p class="text">第<span class="text-label">{{content.order}}</span>:{{content.title}}</p>
    <button :class="active === index?'btn-bottle-green' :'btn-green'" v-for="(item,index) in answer" 
    @click="selectCurrent(index,content.num)" v-preventReClick>{{item}}</button>
  </div>
</template>
<!--多答案-->
<script>
export default {
  props:{
    content: Object
  },
  data(){
    return{
       answer:['A.非常不符合','B.比较不符合','C.有点不符合','D.有点符合','E.比较符合','F.很符合'],
       active:''
    }
  },
  methods:{
     selectCurrent:function(index,num){
      this.active = index;
      setTimeout(() => {
         this.$emit("listenToChildEvent",index+1,num);
      }, 500);
    }
  }
}
</script>
<style scoped>
  p{
    margin:1rem auto 0.64rem auto;
    padding:0.64rem 0.32rem;
    background-color:#61BDA6;
    font-weight:bold;
    color:#ffffff;
    border-radius:10px;
    width:4.8rem;
    height: 1.5rem;
    font-size: 0.32rem;
  }
  .btn-green{
    display: block;
    padding:0.2rem 0.64rem;
    color:#ffffff;
    text-align: left;
    border:none;
    width: 4.2rem;
    margin: 0.32rem auto;
    font-size:0.28rem;
    background-color:#61BDA6;
  }
  .btn-bottle-green{
    display: block;
    padding:0.2rem 0.64rem;
    color:#ffffff;
    text-align: left;
    border:none;
    width: 4.2rem;
    margin: 0.32rem auto;
    font-size:0.28rem;
    background-color:#04684f;
  }
</style>
